import gql from "graphql-tag";

export const GET_NOTIFICATION_SETTING = gql`
  query noification_settings($user_id: uuid) {
    notification_settings(where: { user_id: { _eq: $user_id } }) {
      id
      activity_on_business_page
      activity_on_deals
      activity_on_events
      activity_on_attractions
      messages
      email_activity_on_attractions
      email_activity_on_deals
      email_activity_on_events
      email_message
      email_notifications
      council_updates
      created_at
      updated_at
    }
  }
`;
